import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';

import SlimSelect from 'slim-select'


window.bootstrap = bootstrap;

document.addEventListener("DOMContentLoaded", function (event) {

    const menu_button = document.querySelector('[data-behaviour="toggle-menu"]');

    if (menu_button) {
        menu_button.addEventListener('click', () => {
            document.body.classList.toggle('body--show');
        })
    }

    const slimSelects = document.querySelectorAll('select[data-behaviour="searchable-select"]');
    slimSelects.forEach(select => {
        new SlimSelect({
            select: select
        })
    });

    function initLiveSearch(form, searchResultContainer, action = null) {
        if (!form || !searchResultContainer) return;

        const debounce = (fn, ms = 100) => {
            let t;
            return (...args) => {
                clearTimeout(t);
                t = setTimeout(() => fn(...args), ms);
            };
        };

        const doSearch = async () => {
            let params = new URLSearchParams(new FormData(form));
            const url = new URL(form.action, window.location.origin);

            if (action) {
                url.pathname = url.pathname.replace(action, 'liveSearch');
                params.append('action', action);
            } else {
                url.pathname = url.pathname.replace(/\/$/, '');
                url.pathname += '/liveSearch';
            }
            url.search = params.toString();

            const res = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' }});
            if (!res.ok) return;
            const html = await res.text();
            searchResultContainer.innerHTML = html;
        };

        form.querySelectorAll('input, select, textarea').forEach(el => {
            el.addEventListener('input', debounce(doSearch, 100));
            el.addEventListener('change', debounce(doSearch, 100));
        })
    }

    const mainFormConfigs = [
        { formId: 'Form_FilterForm', resultSelector: '.data-handler .section-items' },
        { formId: 'Form_ListingsFilterForm', resultSelector: '.contact-listing .section-members .section-items', action: 'view' },
        { formId: 'Form_SeminarsFilterForm', resultSelector: '.contact-seminar .section-attendance .section-items', action: 'view' },
        { formId: 'Form_FSJSlotsFilterForm', resultSelector: '.contact-fsjlocation .section-items', action: 'viewLocations' },
        { formId: 'Form_FSJlerFilterForm', resultSelector: '.contact-allfsjler .section-items', action: 'viewAllFSJler' },
        { formId: 'Form_FSJLocationsFilterForm', resultSelector: '.contact-allfsjlocations .section-items', action: 'viewAllFSJLocations' }
    ]

    mainFormConfigs.forEach(config => {
        if (config.formId && config.resultSelector) {
            const form = document.querySelector(`form[id="${config.formId}"]`);
            const searchResult = document.querySelector(config.resultSelector);
            initLiveSearch(form, searchResult, config.action ?? null);
        }
    })

    const modal = document.getElementById('addObjectModal');
    if (modal) {
        modal.addEventListener('shown.bs.modal', function () {
            const modalForm = modal.querySelector('form');
            const modalSearchResult = modal.querySelector('table');
            initLiveSearch(modalForm, modalSearchResult, "add");
        })
    }

    document.querySelectorAll('[data-behaviour="select-all-fields"]').forEach(button => {
        button.addEventListener('click', () => {
            button.closest('.export-fields-group').querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
                checkbox.checked = true;
            });
        });
    });

    document.querySelectorAll('[data-behaviour="unselect-all-fields"]').forEach(button => {
        button.addEventListener('click', () => {
            button.closest('.export-fields-group').querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
                checkbox.checked = false;
            });
        });
    });
});

window.openAllAccordions = function() {
    document.querySelectorAll('.accordion-collapse').forEach(collapse => {
        const bsCollapse = bootstrap.Collapse.getOrCreateInstance(collapse, { toggle: false});
        bsCollapse.show();
    });

}

window.closeAllAccordions = function() {
    document.querySelectorAll('.accordion-collapse').forEach(collapse => {
        const bsCollapse = bootstrap.Collapse.getOrCreateInstance(collapse, { toggle: false});
        bsCollapse.hide();
    });
}
